import { Link, useLocation } from "react-router-dom";
import { Users, Folder, DollarSign, Settings, FileText } from "lucide-react";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";

export default function Sidebar() {
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsCollapsed(window.innerWidth < 900);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const links = [
    { path: "/dashboard/manage", label: "Manage", icon: <Settings size={18} /> },
    { path: "/dashboard/employees", label: "Employees", icon: <Users size={18} /> },
    { path: "/dashboard/categories", label: "Categories", icon: <Folder size={18} /> },
    { path: "/dashboard/expenses", label: "Expenses", icon: <DollarSign size={18} /> },
    { path: "/dashboard/invoice", label: "Invoices", icon: <FileText size={18} /> },
  ];

  return (
    <aside
      style={{
        width: isCollapsed ? "80px" : "230px",
        background: "linear-gradient(180deg, #6A1B9A 0%, #8E24AA 100%)", // 💜 dégradé violet flexible
        color: "white",
        height: "100vh",
        padding: "1.5rem 1rem",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        transition: "all 0.3s ease",
        boxShadow: "4px 0 12px rgba(0, 0, 0, 0.15)",
        position: "sticky",
        top: 0,
        overflowY: "auto",
      }}
    >
    
      <div>
        <motion.h2
          style={{
            fontSize: isCollapsed ? "1.1rem" : "1.4rem",
            fontWeight: "bold",
            marginBottom: "1.5rem",
            textAlign: "center",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          animate={{ opacity: [0, 1], y: [-10, 0] }}
          transition={{ duration: 0.5 }}
        >
          {isCollapsed ? "API" : "Third-Party API"}
        </motion.h2>

   
        <nav style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          {links.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <motion.div
                key={link.path}
                whileHover={{ scale: 1.05, x: 5 }}
                transition={{ type: "spring", stiffness: 250 }}
              >
                <Link
                  to={link.path}
                  style={{
                    color: isActive ? "#FFD700" : "white",
                    textDecoration: "none",
                    padding: "0.7rem 1rem",
                    borderRadius: "0.6rem",
                    backgroundColor: isActive ? "rgba(255, 255, 255, 0.15)" : "transparent",
                    display: "flex",
                    alignItems: "center",
                    gap: isCollapsed ? "0" : "0.75rem",
                    justifyContent: isCollapsed ? "center" : "flex-start",
                    transition: "background-color 0.3s ease, color 0.3s ease",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {link.icon}
                  {!isCollapsed && <span>{link.label}</span>}
                </Link>
              </motion.div>
            );
          })}
        </nav>
      </div>

      {/* --- Pied de page (bouton collapse) --- */}
      <motion.button
        onClick={() => setIsCollapsed(!isCollapsed)}
        whileTap={{ scale: 0.9 }}
        style={{
          marginTop: "auto",
          background: "rgba(255,255,255,0.15)",
          color: "white",
          border: "none",
          borderRadius: "0.5rem",
          padding: "0.6rem",
          cursor: "pointer",
          transition: "background 0.3s ease",
        }}
      >
        {isCollapsed ? "›" : "‹"}
      </motion.button>
    </aside>
  );
}
